import { Injectable } from '@angular/core';
import { DraftBody } from '../../model/DraftBody';
import { MessageService } from '../service-ui/message.service';
import { HttpClient } from '@angular/common/http';
import { StartupService } from '../service-ui/startup.service';
import { AbstractLiveDataService } from './abstract-live-data.service';
import { NotificationsService } from './notifications.service';

@Injectable()
export class DraftBodyService extends AbstractLiveDataService<DraftBody> {

  constructor(private httpa: HttpClient, private messageServicea: MessageService, private startupServicea: StartupService, protected notificationsService: NotificationsService) {
    super(httpa, messageServicea, startupServicea, notificationsService);
    this.notificationsService.setDraftBodyService(this);
    this.notificationsService.startNotification();
  }

  makeObjectInstance(args: any): DraftBody {
    return new DraftBody(args);
  }

  getLoggingObjectTypeName(): string {
    return 'DraftBody';
  }

  supportsParallel(): boolean {
    return false;
  }

  getURLEndPoint(): string {
    return 'draftbody';
  }

  getLinkData(): any[] {
    return [
      { action: 'Link', objectIdPropertyName: 'resource_ID', serviceName: 'resourceService', arrayProperty: 'draftBodys', objectProperty: 'resource'},
    ];
  }
}

